<template>
  <div class="car_list_box">
    <div class="fillter_box row m-0">
      <!--
        <div class="col-4 p-0 pl-1 pr-1">
          <common-single-dropDown :label="''"
                                  :options="options1"
                                  :currentValue="options1Value"
                                  :placeHolder="'전체 지점'"
                                  @selectChange="v => this.options1Value = v"
          />
        </div>
        
        <div class="col-4 p-0 pl-1 pr-1">
          <common-single-dropDown :label="''"
                                  :options="options2"
                                  :currentValue="options2Value"
                                  :placeHolder="'전체 모델'"
                                  @selectChange="v => this.options2Value = v"
          />
        </div>
        
        <div class="col-4 p-0 pl-1 pr-1">
          <common-autocomplete
            :min="1"
            :max="1000"
            :data="carNumber.data"
            @input="v => {if(v.length === 0) this.carNumber.value = v, this.init(0)}"
            @search="v => {this.carNumber.value = v, this.init(0)}"
            :placeholder="'차량번호'"
          />
        </div>
      -->
      <div class="col-10 p-1 pl-5 pr-0">
        <b-input-group>
          <b-input size="sm" type="text" class="option-item search-input" v-model="searchOption" placeholder="차량번호/제조사/모델" />
          <b-input-group-append>
            <b-button class="input-icon" variant="primary" size="sm" :class="{active : false, hover: false}"
                    >
                    <i class="search"><img src="../../public/img/icon/icon_search.png" height="12" width="12"/></i>
            </b-button>
        </b-input-group-append>
        </b-input-group>
      </div>
    </div>
    <div class="col-12 pt-2 car_list_over">
      <div class="card-group mb-2" v-for="(item, index) in displayItems" :key="index">
        <div class="card border-0" style="cursor:pointer;">
          <div @click="carClick(index)">
            <div class="logo" :style="brandIconBg(item.brand)"><span class="d-none">{{ item.brand }}</span></div>
            <ul class="car_info">
              <li class="car_number">{{ item.num }}</li>
              <li class="car_state" :class="(item.brk === '1') ? 'text-muted' : 'text-info' ">
                {{ (item.brk === '0') ? '운행중' : '주차' }}
              </li>
              <!-- <li class="car_error text-danger"> {{ item.dtcs }}</li> -->
            </ul>
            <p class="car_model"> {{ item.brand }} {{ item.model }} {{ item.year }} </p>
            
            <div class="car_km">
              {{ item.t_dist | comma }}km │ {{ item.c_date || '단말기 미통신' }}
            </div>
          </div>
          <div class="car_addr detail_btn" @click="lastGps(index)" :text="item.address">
            {{ item.address }}
          </div>
          <div class="more">
            <b-dropdown size="sm" dropright variant="link" toggle-class="text-decoration-none shadow-none" no-caret>
              <template v-slot:button-content>
                <img src="/img/icon/icon_more.png" height="24" width="24" alt="더보기"/>
              </template>
              <!-- <b-dropdown-item link-class="custom_dropdown_item" href="#" @click="carClick(index)">최근 운행 경로
              </b-dropdown-item>
              <b-dropdown-item link-class="custom_dropdown_item" :href="'/car/'+item.seq+'/expend'">소모품 관리
              </b-dropdown-item> -->
              <b-dropdown-item link-class="custom_dropdown_item" :href="'/car/'+item.seq+'/diag'"> 차량 진단 및 평가 </b-dropdown-item>
              <!-- <b-dropdown-item link-class="custom_dropdown_item" :href="'/issue/'+item.seq">사고 관리</b-dropdown-item>
              <b-dropdown-item link-class="custom_dropdown_item" :href="'/history/'+item.seq+'/drive'">이력 관리</b-dropdown-item> -->
            </b-dropdown>
          </div>
        </div>
      </div>
      <div class="card-group mb-2 text-center" v-if="displayItems.length === 0">등록된 차량이 없습니다.</div>
      <div class="mb-2" v-show="selectedCar">
        <button type="button" class="btn btn-sm btn-outline-dark p-1 btn-block all_list shadow-none"
                @click="reInit">전체 차량
        </button>
      </div>
      <div class="card mt-3 custom_calendar border-0">
        <!--<div style="width:311px; height: 315px; background-image: url('/img/sample/calendar.png');opacity: 0.5;"></div>-->
        <VCalendar ref="calendar" :dates="dates" v-show="selectedCar" @selectedDay="selectedDay"
                   @changeCalendar="changeCalendar"/>
      </div>
    </div>
  </div>
</template>

<script>

import commonSingleDropDown from '@/components/common/dropdown/SingleDropDown'
import commonAutocomplete from '@/components/common/inputbox/Autocomplete'
import VCalendar from '@/components/common/calendar/VCalendar'
import '@/filter/common'
import brandIconBg from '@/mixin/brandIconBg'
import ax from '@/api/car'
import axLocation from '@/api/location'

export default {
  name: 'CarListBox',
  mixins: [brandIconBg],
  components: {
    commonSingleDropDown,
    commonAutocomplete,
    VCalendar
  },
  data () {
    return {
      options1: [
        { text: '전체 지점1', value: '0' },
        { text: '전체 지점2', value: '1' }
      ],
      options1Value: '0',
      options2: [
        { text: '전체 지점1', value: '0' },
        { text: '전체 지점2', value: '1' }
      ],
      options2Value: '0',
      carNumber: {
        data: [],
        value: null
      },
      items: [],
      displayItems: [],
      selectedCar: null,
      dates: [],
      address: [],
      searchOption: ""
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.selectedCar = null
      ax.smallCarList(response => {
        this.items = response
        // todo::총주행거리 100만 이상일 시 데이터 보정 필요
        this.items.forEach((item, index) => {
          if(item.t_dist > 1000000 || item.t_dist <= 0) {
            ax.lastCarTdist(item.id, res => {
              this.items[index].t_dist = res.t_dist
              this.items[index].c_date = res.c_date
            })
          }
        })

        this.displayItems = this.items
      })
    },
    reInit () {
      this.selectedCar = null
      this.displayItems = this.items
      this.$emit('reInit')
    },
    carClick (carIndex) {
      if (!this.selectedCar) {
        this.selectedCar = this.items[carIndex]
        this.displayItems = [this.selectedCar]
        if (this.selectedCar.id)
          this.$refs.calendar.initCalendarDays()
      }
      this.$emit('reInit')
    },
    selectedDay (date) {
      let y = date.getFullYear() + ''
      let m = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : ((date.getMonth() + 1) + '')
      let d = date.getDate() < 10 ? '0' + (date.getDate()) : (date.getDate() + '')

      // console.log(this.selectedCar.id, `${y}${m}${d}`);
      this.$emit('selectDay', this.selectedCar.id, `${y}${m}${d}`)
    },
    changeCalendar (startDate, endDate) {
      if (this.selectedCar) {
        let sy = startDate.getFullYear() + ''
        let sm = (startDate.getMonth() + 1) < 10 ? '0' + (startDate.getMonth() + 1) : ((startDate.getMonth() + 1) + '')
        let sd = startDate.getDate() < 10 ? '0' + (startDate.getDate()) : (startDate.getDate() + '')

        let ey = endDate.getFullYear() + ''
        let em = (endDate.getMonth() + 1) < 10 ? '0' + (endDate.getMonth() + 1) : ((endDate.getMonth() + 1) + '')
        let ed = endDate.getDate() < 10 ? '0' + (endDate.getDate()) : (endDate.getDate() + '')

        if (this.selectedCar.id) {
          ax.carMonthCount(this.selectedCar.id, `${sy}${sm}${sd}`, `${ey}${em}${ed}`, response => {
            this.dates = response
          })
        }
      }
    },
    lastGps (idx) {
      axLocation.lastGps(this.items[idx].id, response => {
        if (response) {
          this.items[idx].address = response
          this.$emit('lastGpsSelected', this.items[idx].address, this.items[idx].gps_y, this.items[idx].gps_x, this.items[idx].c_date)
        } else {
          this.items[idx].address = '현재위치 보기 실패'
        }
      })
    }
  },
  watch: {
    searchOption() {
        let searchList = []

        if (this.searchOption == null || this.searchOption == '') {
            this.displayItems = this.items
        } else {
            this.items.forEach(item => {
                if (item.id == this.searchOption || item.num == this.searchOption || item.brand == this.searchOption || item.model == this.searchOption) {
                    searchList.push(item)
                }
            });

            this.displayItems = searchList
        }
    }
  }
}
</script>

<style lang="scss" scoped>
.car_list_box {
  z-index: 99;
  width: 335px;
  background-color: #F8F8FB;
  height: calc(100vh - 64px);

  .fillter_box {
    height: 55px;
    padding: 12px 9px;
  }

  .car_list_over {
    overflow-y: auto;
    height: calc(100vh - 125px);
  }

  .card-group {
    .card {
      position: relative;
      padding: 12px;
      font-size: 12px;

      .logo {
        display: inline-block;
        height: 40px;
        width: 40px;
        /*background-color: #999;*/
        position: absolute;
        background: {
          repeat: no-repeat;
          position: center center;
        }
      }

      .car_info {
        float: left;
        list-style: none;
        margin-left: 45px;
        margin-bottom: 0px;
        vertical-align: middle;

        li {
          float: left;
          display: inline-block;

          &.car_number {
            display: inline-block;
            font-size: 14px;
            line-height: 20px;
            word-break: break-all;
            white-space: nowrap;
          }

          &.car_state {
            width: 55px;
            line-height: 20px;
            text-align: right;
            vertical-align: middle;
          }

          /*          
          &.car_state:after {
            content: ' |';
            font-size: 11px;
            vertical-align: top;
            padding-left: 5px;
            padding-right: 5px;
          }
          */
          
          &.car_error {
            line-height: 20px;
            text-align: right;
            vertical-align: middle;
          }
        }
      }

      .car_model {
        clear: both;
        margin-left: 45px;
        margin-bottom: 10px;
        font-size: 12px;
        display: block;
      }

      /* 
      .car_model {
        clear: both;
        color: #979799;
      }
      */

      .car_km {
        color: #000;
      }

      .car_addr {
        padding-top: 8px;
        color: #979799;
      }

      .more {
        position: absolute;
        right: 0px;
        top: 5px;
        cursor: pointer;

        ::v-deep .dropdown-menu {
          background: #FFFFFF !important;
          box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05) !important;
          border-radius: 8px !important;
          min-width: 8rem !important;
        }

        ::v-deep .custom_dropdown_item {
          font-size: 12px !important;
          padding: 5px 15px;
        }

      }
    }
  }

  .all_list {
    font-size: 80%;
  }
}

::v-deep .vfc-main-container {
  box-shadow: none;
  background: #FFFFFF;
  border: 0px solid #f0f0f0;
  border-radius: 8px;
}
</style>
